//SmartDrillMTable.jsx
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MainLayout from '../../layouts/MainLayout';
import './SmartDrill.css';
import './FourLines.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeUp } from '@fortawesome/free-solid-svg-icons';
import CountingNumbers from '../../assets/pageimages/CountingNumbers.webp';

function SmartDrillMTable() {
  const authState = useSelector(state => state.authReducer);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [selectedLanguage, setSelectedLanguage] = useState('English'); // Default language
  const [selectedMethod, setSelectedMethod] = useState('View'); // Default method
  const [selectedMedium, setSelectedMedium] = useState('MADSmania Sheets'); // Default medium
  const [selectedPracticeWith, setSelectedPracticeWith] = useState('Solo'); // Default practiced with
  const [selectedGroup, setSelectedGroup] = useState('Single Number List'); // Default group
  const [number, setNumber] = useState('');
  const [fromNumber, setFromNumber] = useState('');
  const [toNumber, setToNumber] = useState('');
  const [multiplicationTable, setMultiplicationTable] = useState([]);
  const [error, setError] = useState('');
  const [number1, setNumber1] = useState('');
  const [number2, setNumber2] = useState('');
  const [number3, setNumber3] = useState('');
  const [showTimer, setShowTimer] = useState(false);

  const [elapsedTimeMs, setElapsedTimeMs] = useState(0);
  const [timerDisabled, setTimerDisabled] = useState(false);
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(false);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  // const [practiceData, setPracticeData] = useState([]);

  const [practiceData, setPracticeData] = useState(() => {
    const savedData = localStorage.getItem('practiceData');
    return savedData ? JSON.parse(savedData) : [];
  });


  useEffect(() => {
    const interval = setInterval(() => {
      setElapsedTime(prevTime => prevTime + 1);
    }, 1000); // Update elapsed time every second

    return () => clearInterval(interval);
  }, []);

  // Function to save practice data locally
  const savePracticeDataLocally = (data) => {
    const savedData = JSON.parse(localStorage.getItem('practiceData')) || [];
    savedData.push(data);
    localStorage.setItem('practiceData', JSON.stringify(savedData));
  };

  // // Sync local data with server
  // const syncDataWithServer = () => {
  //   const savedData = JSON.parse(localStorage.getItem('practiceData')) || [];
  //   if (savedData.length > 0) {
  //     // Replace this with your actual API call to save data to the server
  //     fetch('/api/sync', {
  //       method: 'POST',
  //       body: JSON.stringify(savedData),
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //     })
  //     .then(response => response.json())
  //     .then(() => {
  //       // Clear local storage after successful sync
  //       localStorage.removeItem('practiceData');
  //     })
  //     .catch(err => {
  //       console.error('Failed to sync data with server:', err);
  //     });
  //   }
  // };

  // useEffect(() => {
  //   window.addEventListener('online', syncDataWithServer);

  //   return () => {
  //     window.removeEventListener('online', syncDataWithServer);
  //   };
  // }, []);

  const handleSavePractice = () => {
    const endTime = Date.now();
    const elapsedTimeMs = endTime - startTime;

    let ecoPoints = 0;
    if (selectedMedium === 'MADSmania Sheets') {
      ecoPoints = 25;
    } else if (selectedMedium === 'Paper / Notebook' || selectedMedium === 'By Heart') {
      ecoPoints = 5;
    }

    const practiceData = {
      userId: authState.user.id,
      userName: authState.user.name,
      practiceLanguage: selectedLanguage,
      methodName: selectedMethod,
      mediumName: selectedMedium,
      groupName: selectedGroup,
      practicedWith: selectedPracticeWith,
      startTime: new Date(startTime),
      endTime: new Date(endTime),
      elapsedTimeMs,
      ecoPoints,
      page: 'SMARTDrill Multiplication',
      dateCreated: new Date()
    };

    savePracticeDataLocally(practiceData);
    setSaveButtonDisabled(true);

    if (navigator.onLine) {
      syncDataWithServer();
    }
  };

  const formatTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  const languageList = [
    'Arabic', 'Assamese', 'Bangla', 'Burmese', 'Chinese', 'English', 'French', 'German', 'Gujarati', 'Hindi', 'Italian',
    'Javanese', 'Japanese', 'Kannada', 'Korean', 'Malayalam', 'Marathi', 'Odia', 'Polish', 'Portuguese',
    'Punjabi', 'Russian', 'Sinhala', 'Spanish', 'Tamil', 'Telugu', 'Thai', 'Turkish', 'Urdu', 'Vietnamese'
  ];

  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
  };

  const groupList = [
    "Single Number List", "Single Number Times Table", "Number Range", "Multiple Numbers"
  ];

  const handleGroupChange = (group) => {
    setSelectedGroup(group);
  };

  const methodList = [
    'View', 'Listen', 'By Heart'
  ];

  const handleMethodChange = (method) => {
    setSelectedMethod(method);
  };

  const mediumList = [
    'MADSmania Sheets', 'Paper / Notebook', 'By Heart', 'Others'
  ];

  const handleMediumChange = (medium) => {
    setSelectedMedium(medium);
  };

  const practicewithList = [
    'Solo', 'Mother', 'Teacher', 'Father', 'Brother', 'Sister', 'Friend', 'Relatives', 'Others'
  ];

  const handlePracticeWithChange = (practicewith) => {
    setSelectedPracticeWith(practicewith);
  };

  const handleNumberChange = (e) => {
    setNumber(e.target.value);
  };

  const handleFromNumberChange = (e) => {
    setFromNumber(e.target.value);
  };

  const handleToNumberChange = (e) => {
    setToNumber(e.target.value);
  };

  const handleNumber1Change = (e) => {
    setNumber1(e.target.value);
  };

  const handleNumber2Change = (e) => {
    setNumber2(e.target.value);
  };

  const handleNumber3Change = (e) => {
    setNumber3(e.target.value);
  };

  const handleShowTable = () => {
    if (selectedGroup === 'Single Number List') {
      if (!isNaN(number) && number > 0) {
        const table = Array.from({ length: 10 }, (_, i) => {
          return { value: number * (i + 1) };
        });
        setMultiplicationTable(table);
      }
    } else if (selectedGroup === 'Single Number Times Table') {
      if (!isNaN(number) && number > 0) {
        const table = Array.from({ length: 10 }, (_, i) => {
          return { value: `${number} x ${i + 1} = ${number * (i + 1)}` };
        });
        setMultiplicationTable(table);
      }
    } else if (selectedGroup === 'Number Range') {
      const from = parseInt(fromNumber, 10);
      const to = parseInt(toNumber, 10);

      if (isNaN(from) || isNaN(to) || from <= 0 || to <= 0 || to > from + 10) {
        setError('Invalid range. "To" number must not be more than 10 greater than the "From" number.');
        setMultiplicationTable([]);
      } else {
        setError('');
        const table = Array.from({ length: 10 }, (_, i) => {
          return Array.from({ length: to - from + 1 }, (_, j) => {
            return { value: (from + j) * (i + 1) };
          });
        });
        setMultiplicationTable(table);
      }
    } else if (selectedGroup === 'Multiple Numbers') {
      if (!number1 || !number2 || !number3) {
        setError('Please enter all three numbers.');
        setMultiplicationTable([]);
      } else {
        setError('');
        const table = [
          Array.from({ length: 10 }, (_, i) => ({ value: number1 * (i + 1) })),
          Array.from({ length: 10 }, (_, i) => ({ value: number2 * (i + 1) })),
          Array.from({ length: 10 }, (_, i) => ({ value: number3 * (i + 1) }))
        ];
        setMultiplicationTable(table);
      }
    }
    if (!error && multiplicationTable.length > 0) {
      setShowTimer(true);
      setStartTime(Date.now());
      setTimerDisabled(true);
    }
  };

  // const handleSavePractice = () => {
  //   // clearInterval(interval);
  //   // Calculate the end time and elapsed time
  //   const endTime = Date.now();
  //   const elapsedTimeMs = endTime - startTime;
  //   const elapsedTimeSeconds = elapsedTimeMs / 1000;

  //   // Calculate ecoPoints based on selectedMedium
  //   let ecoPoints = 0;
  //   if (selectedMedium === 'MADSmania Sheets') {
  //     ecoPoints = 25;
  //   } else if (selectedMedium === 'Paper / Notebook' || selectedMedium === 'By Heart') {
  //     ecoPoints = 5;
  //   } else {
  //     ecoPoints = 0;
  //   }

  //   // Create the data object
  //   const practiceData = {
  //     userId: authState.user.id,
  //     userName: authState.user.name,
  //     practiceLanguage: selectedLanguage,
  //     methodName: selectedMethod,
  //     mediumName: selectedMedium,
  //     groupName: selectedGroup,
  //     practicedWith: selectedPracticeWith,
  //     startTime: new Date(startTime),
  //     endTime: new Date(endTime),
  //     elapsedTimeMs,
  //     ecoPoints: ecoPoints,
  //     page: 'SMARTDrill Multiplication',
  //     dateCreated: new Date()
  //   };

  //   const newPracticeData = {
  //     userId: authState.user.id,
  //     userName: authState.user.name,
  //     practiceLanguage: selectedLanguage,
  //     methodName: selectedMethod,
  //     mediumName: selectedMedium,
  //     groupName: selectedGroup,
  //     practicedWith: selectedPracticeWith,
  //     startTime: new Date(startTime),
  //     endTime: new Date(endTime),
  //     elapsedTimeMs,
  //     ecoPoints: ecoPoints,
  //     page: 'SMARTDrill Multiplication',
  //     dateCreated: new Date()
  //   };
  //   // Navigate to SMARTDrillPracticeSummary with practiceData
  //   // For now, let's just log the data
  //   // console.log('Practice Data:', practiceData);
  //   // setPracticeData(practiceData);
  //   // setPracticeData(prevData => [...prevData, practiceData]);
  //   // setSaveButtonDisabled(true);
  //   setPracticeData(prevData => {
  //     const updatedData = [...prevData, newPracticeData];
  //     localStorage.setItem('practiceData', JSON.stringify(updatedData));
  //     return updatedData;
  //   });
  //   setSaveButtonDisabled(true);
  // };

  useEffect(() => {
    const updateOnlineStatus = () => {
      if (navigator.onLine) {
        // Sync data with server if needed
      }
    };
  
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);
  
    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  }, []);

  const syncDataWithServer = async () => {
    const savedData = JSON.parse(localStorage.getItem('practiceData')) || [];
  
    const unsyncedData = savedData.filter(item => !item.synced);
  
    if (unsyncedData.length === 0) {
      return;
    }
  
    try {
      const response = await fetch('/api/sync-practice-data', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(unsyncedData)
      });
  
      if (response.ok) {
        // Mark data as synced
        const syncedData = savedData.map(item =>
          unsyncedData.includes(item) ? { ...item, synced: true } : item
        );
        localStorage.setItem('practiceData', JSON.stringify(syncedData));
        setPracticeData(syncedData);
      } else {
        console.error('Failed to sync data with the server.');
      }
    } catch (error) {
      console.error('Error syncing data:', error);
    }
  };

  useEffect(() => {
    const updateOnlineStatus = () => {
      if (navigator.onLine) {
        syncDataWithServer();
      }
    };
  
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);
  
    // Try to sync when the component mounts if online
    if (navigator.onLine) {
      syncDataWithServer();
    }
  
    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  }, []);


  const handlePracticeAgain = () => {
    setMultiplicationTable([]);
    setError('');
    setNumber('');
    setFromNumber('');
    setToNumber('');
    setNumber1('');
    setNumber2('');
    setNumber3('');
    setShowTimer(false);
    setStartTime(null);
    setEndTime(null);
    setElapsedTimeMs(0);
    setSaveButtonDisabled(false);
    setPracticeData(prevData => {
      if (!prevData) return []; 
      return [...prevData, prevData]; 
    });
  };

  const handlePracticeOver = () => {
    // console.log('Practice Over');
  };

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mb-2 mx-2 border-b border-b-gray-300 text-white'>SMARTDrill - Multiplication Tables</h2>
      </div>

      <div className="mx-auto max-w-[760px]">
        <div className="flex justify-center mt-1 mb-1 ml-4 mr-4 relative">
          <img className="align-middle" src={CountingNumbers} alt="CountingNumbers" />
          <div className="timer-and-speaker absolute top-0 right-0 flex items-center">
            <span className="timer">{formatTime(elapsedTime)}</span>
            <FontAwesomeIcon icon={faVolumeUp} className="ml-2" />
          </div>
        </div>
        <div className="flex justify-center mb-1">
          <div className='ml-4'>
            <p className='text-white'>Language</p>
            <select value={selectedLanguage} onChange={(e) => handleLanguageChange(e.target.value)} className="p-2">
              {languageList.map((language, index) => (
                <option key={index} value={language}>{language}</option>
              ))}
            </select>
          </div>
          <div className='ml-4'>
            <p className='text-white'>Group</p>
            <select value={selectedGroup} onChange={(e) => handleGroupChange(e.target.value)} className="ml-2 p-2">
              {groupList.map((group, index) => (
                <option key={index} value={group}>{group}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="flex justify-center mb-1">
          <div className='ml-4'>
            <p className='text-white'>Practice Method</p>
            <select value={selectedMethod} onChange={(e) => handleMethodChange(e.target.value)} className="p-2 ml-2">
              {methodList.map((method, index) => (
                <option key={index} value={method}>{method}</option>
              ))}
            </select>
          </div>
          <div className='ml-4'>
            <p className='text-white'>Practice Medium</p>
            <select value={selectedMedium} onChange={(e) => handleMediumChange(e.target.value)} className="p-2 ml-2">
              {mediumList.map((medium, index) => (
                <option key={index} value={medium}>{medium}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="flex justify-center mb-1">
          <div className='ml-4'>
            <p className='text-white'>Practicing With</p>
            <select value={selectedPracticeWith} onChange={(e) => handlePracticeWithChange(e.target.value)} className="p-2 ml-2">
              {practicewithList.map((practicewith, index) => (
                <option key={index} value={practicewith}>{practicewith}</option>
              ))}
            </select>
          </div>
        </div>
        {(selectedGroup === 'Single Number List' || selectedGroup === 'Single Number Times Table') && (
          <>
            <div className="flex justify-center mb-2">
              <input
                type="number"
                value={number}
                onChange={handleNumberChange}
                className="p-2 border border-gray-300"
                placeholder="Enter a number"
              />
            </div>
            <button onClick={handleShowTable} className="ml-2 p-2 bg-blue-500 text-white">Show Table</button>
            {showTimer && (
          <div className="text-white text-center my-4">
            Practice Timer: {formatTime(elapsedTime)}
          </div>
        )}
          </>
        )}
        {selectedGroup === 'Number Range' && (
          <>
            <div className="flex justify-center mb-2">
              <input
                type="number"
                value={fromNumber}
                onChange={handleFromNumberChange}
                className="p-2 border border-gray-300"
                placeholder="From"
              />
              <input
                type="number"
                value={toNumber}
                onChange={handleToNumberChange}
                className="ml-2 p-2 border border-gray-300"
                placeholder="To"
              />
            </div>
            <button onClick={handleShowTable} className="ml-2 p-2 bg-blue-500 text-white">Show Table</button>
            {showTimer && (
          <div className="text-white text-center my-4">
            Practice Timer: {formatTime(elapsedTime)}
          </div>
        )}
          </>
        )}
        {selectedGroup === 'Multiple Numbers' && (
          <>
            <div className="flex justify-center mb-2">
              <input
                type="number"
                value={number1}
                onChange={handleNumber1Change}
                className="p-2 border border-gray-300"
                placeholder="Enter number 1"
              />
              <input
                type="number"
                value={number2}
                onChange={handleNumber2Change}
                className="ml-2 p-2 border border-gray-300"
                placeholder="Enter number 2"
              />
              <input
                type="number"
                value={number3}
                onChange={handleNumber3Change}
                className="ml-2 p-2 border border-gray-300"
                placeholder="Enter number 3"
              />
            </div>
            <button onClick={handleShowTable} disabled={timerDisabled} className="ml-2 p-2 bg-blue-500 text-white">Show Table</button>
            {showTimer && (
          <div className="text-white text-center my-4">
            Practice Timer: {formatTime(elapsedTime)}
          </div>
        )}
          </>
        )}
        {error && (
          <div className="text-red-500 text-center mb-2">{error}</div>
        )}
        {multiplicationTable.length > 0 && selectedGroup === 'Number Range' && (
          <div className="mx-auto justify-center items-center max-w-[760px] bg-gray-800 p-4 rounded">
            <div className="grid grid-cols-10 gap-1">
              {Array.from({ length: 10 }, (_, colIndex) => (
                <div key={colIndex} className="flex flex-col">
                  {multiplicationTable.map((row, rowIndex) => (
                    <div
                      key={`${rowIndex}-${colIndex}`}
                      className={`p-2 ${colIndex % 2 === 0 ? 'bg-yellow-500 text-black' : 'bg-white text-black'} text-xl`}
                      style={{ textAlign: 'center' }}
                    >
                      {row[colIndex].value}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        )}
        {multiplicationTable.length > 0 && (selectedGroup === 'Single Number List' || selectedGroup === 'Single Number Times Table') && (
          <div className="mx-auto justify-center items-center max-w-[760px] bg-gray-800 p-4 rounded">
            {multiplicationTable.map((item, index) => (
              <div key={index} className={`text-center p-2 ${item.value % 2 === 0 ? 'bg-black text-white' : 'bg-white text-black'}`}>
                {item.value}
              </div>
            ))}
          </div>
        )}
        {multiplicationTable.length > 0 && selectedGroup === 'Multiple Numbers' && (
          <div className="mx-auto max-w-[760px] bg-gray-800 p-4 rounded">
            <table className="w-full">
              <thead>
                <tr>
                  <th className="p-2 bg-blue-500 text-white">Number 1</th>
                  <th className="p-2 bg-blue-500 text-white">Number 2</th>
                  <th className="p-2 bg-blue-500 text-white">Number 3</th>
                </tr>
              </thead>
              <tbody>
                {multiplicationTable[0].map((_, index) => (
                  <tr key={index}>
                    {multiplicationTable.map((column, colIndex) => (
                      <td key={colIndex} className={`p-2 ${column[index].value % 2 === 0 ? 'bg-black text-white' : 'bg-white text-black'}`}>
                        {column[index].value}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {showTimer && (
          <div className="flex justify-center mb-2">
            <button onClick={handleSavePractice} disabled={saveButtonDisabled} className="ml-2 p-2 bg-green-500 text-white">Save Practice</button>
          </div>
        )}
        {showTimer && (
          <div className="flex justify-center mb-2">
            <button onClick={handlePracticeAgain} className="ml-2 p-2 bg-green-500 text-white">Practice Again</button>
            <button onClick={handlePracticeOver} className="ml-2 p-2 bg-red-500 text-white">Practice Over</button>
          </div>
        )}
        {practiceData && (
          <div className="mt-4 p-4 bg-gray-200 rounded">
            <h3 className="text-lg font-bold mb-2 text-blue-700">Practice Data</h3>
            <pre>{JSON.stringify(practiceData, null, 2)}</pre>
          </div>
        )}
      </div>
    </MainLayout>
  );
}

export default SmartDrillMTable;
